// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"69540e09e73ff62c20ec","524":"24e8c5bd41a3be99de99","927":"bb570b9c3f42c784cf3b"}[chunkId] + ".css";
};